module.exports = __webpack_public_path__ + "img/Group 2@2x.a3f3bb93.png";